import { render } from "./IframeComponent.vue?vue&type=template&id=2a2179fe&scoped=true"
import script from "./IframeComponent.vue?vue&type=script&lang=js"
export * from "./IframeComponent.vue?vue&type=script&lang=js"

import "./IframeComponent.vue?vue&type=style&index=0&id=2a2179fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2179fe"]])

export default __exports__